// extracted by mini-css-extract-plugin
export var backdropBlur = "_jp-0";
export var contentCard = "_jp-5";
export var frame = "_jp-2";
export var image = "_jp-4";
export var imagePane = "_jp-3";
export var modal = "_jp-1";